import React from "react";
import Com from "components/styledComp/CommStyledComp";

const processSteps = [
  {
    number: "01",
    title: "환경 분석",
    description: "고객사 운영 환경과 사용자, 단말기, 외부 시스템 연동 범위를 파악합니다.",
  },
  {
    number: "02",
    title: "테넌트 구성",
    description: "고객사별 데이터, 권한, 정책과 관리자 환경을 독립적으로 구성합니다.",
  },
  {
    number: "03",
    title: "시스템 연동",
    description: "웹 관리 환경과 단말기, 인사·조직 시스템을 API 기반으로 연결합니다.",
  },
  {
    number: "04",
    title: "배포·전환",
    description: "사전 검증을 거쳐 서비스 중단을 최소화하며 클라우드 환경으로 전환합니다.",
  },
  {
    number: "05",
    title: "관제·개선",
    description: "상태와 성능을 모니터링하고 보안 패치와 기능 업데이트를 지속 반영합니다.",
  },
];

const SaaSProcess = () => {
  return (
    <Com.DivDetailSection>
      <Com.DivDetailHeading>
        <Com.DetailHeading>클라우드 운영 흐름</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          도입부터 운영·개선까지 하나의 서비스 체계로 연결합니다
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <Com.OlProcessFlow>
        {processSteps.map((step) => (
          <Com.LiProcessStep key={step.number}>
            <Com.SpanProcessNumber>STEP {step.number}</Com.SpanProcessNumber>
            <Com.StrongCardTitle>{step.title}</Com.StrongCardTitle>
            <Com.PCardDescription>{step.description}</Com.PCardDescription>
          </Com.LiProcessStep>
        ))}
      </Com.OlProcessFlow>
    </Com.DivDetailSection>
  );
};

export default SaaSProcess;
